<template>
  <div class="bot-paused-banner">
    <div class="bot-paused-banner__content">
      <div>Conversation is with a human</div>
      <n-button @click="emit('resume')" variant="primary">Resume Bot</n-button>
    </div>
  </div>
</template>

<script lang="ts" setup>
const emit = defineEmits<{
  (e: 'resume'): void;
}>();
</script>

<style lang="scss" scoped>
.bot-paused-banner {
  &__content {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    background-color: $color-netcall-jonquil;
    z-index: 4;
    display: flex;
    padding: 0.75rem;
    align-items: center;
    justify-content: center;
    .btn {
      margin-left: 1rem;
    }
  }
}
</style>
